<template>
    <div class="eventList" v-infinite-scroll="loadMore" infinite-scroll-disabled="pullUpLoading" infinite-scroll-distance="10">
        <section class="selectFixed">
            <div class="bg_fff fixedBox flex_box fs14">
                <p v-if="!query.company" :class="{ upIcon: openList === 'event' }" @click="openOptions('event')">{{ eventActive }}
                    <img src="../assets/img/icon/icon_down_black.svg" alt="downIcon">
                </p>
                <p :class="{ upIcon: openList === 'time' }" @click="openOptions('time')">{{ timeActive }}
                    <img src="../assets/img/icon/icon_down_black.svg" alt="downIcon">
                </p>
            </div>
        </section>
        <section @click="checkIndex(index)" class="listBg" v-for="(item, index) in renderList" :key="item._id">
            <div v-if="query.company" class="flex_box topContent align-items_center co_666">
                <span class="littlePoint"></span>
                <p class="fs12 flex_1">{{ item.content }}</p>
                <span class="fs10">{{ item.updatedStr }}</span>
            </div>
            <div class="listBox flex_box">
<!--                <p class="leftCheckBox"><img :src="selectArr.includes(index) ? allChoose : noChoose" alt=""></p>-->
                <div>
                    <p class="elli2 fs14 co_333">{{ item.title || item.eventTitle }}</p>
                    <p class="flex_box flex_wrap tags mt8">
                    <span class="commonTag fs10" v-for="(itemTag, tagIndex) in item.tags_v2" :key="itemTag.key + tagIndex"
                          :class="{ yellowTag: item.tendency === '负面' && itemTag && itemTag.key === 'yinbao', greenTag: ['正面', '中性'].includes(item.tendency), redTag: item.tendency === '负面' }">{{ itemTag.value }}</span>
                    </p>
                    <p class="fs10 co_B0">{{ item.latestDateStr }}</p>
                </div>
            </div>
        </section>

        <img v-if="!renderList.length" class="noDataImg hasMargin" src="../assets/img/company/noEventData.svg" alt="">

<!--        <section class="footBoxBg mt12 ">-->
<!--            <div class="footBox flex_box fs18">-->
<!--                <div @click="checkIndex('allCheck')" class="leftBox"><img :src="selectArr.length < 1 ? noChoose : selectArr.length  === renderList.length ? allChoose : partChoose" alt=""> 全选</div>-->
<!--                <div @click="sendEvent" class="rightBox flex_1 co_fff font_b text_c">一键发送</div>-->
<!--            </div>-->
<!--        </section>-->
        <!-- loading box -->
        <section class="loadingBg" v-if="loading">
            <mt-spinner type="double-bounce" color="#26a2ff"></mt-spinner>
        </section>
        <section v-if="openList" class="popupChooseBox">
            <EventChoose :popupVisible="popupVisible" :renderType="openList" :activeOption="activeOption" @selectedOption="selectedOption"></EventChoose>
        </section>
        <div class="place"></div>
        <div :class="['exportFooter', 'fs16', 'bg_deepBule', 'co_fff', {inActive: !isLogin}]" v-if=" !query.company && renderList.length">
            <p @click="gotoExportPage()">发送至邮箱</p>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import utils from "@/util/common";
import _ from "lodash";
import common from "@/util/common";

const noChoose = require('../assets/img/icon/noChoose.png')
const allChoose = require('../assets/img/icon/allChoose.png')
const partChoose = require('../assets/img/icon/partChoose.png')

export default {
    name: "EventList",
    components: {
        EventChoose(render){ require(["@/components/common/EventChoose"], render) },
    },
    data() {
        return {
            currentPage: 0,
            firstLoad: true,
            loading: false,
            pullUpLoading: false,
            query: {
                industry: '金融业',
                company: "",
                start: moment().startOf('day').valueOf(),
                end: moment().endOf('day').valueOf(),
                skip: 0,
                limit: 20
            },
            renderList: [],
            openList: '',
            noChoose: noChoose,
            allChoose: allChoose,
            partChoose: partChoose,
            selectArr: [],
            activeOption: '',
            eventActive: '全部事件',
            timeActive: '今日',
            popupVisible: false,
            isLogin: !!utils.getCookie("xinhuaToken")
        }
    },
    mounted() {
        let { company } = this.$route.query;
        this.query.company = company || "";
        if(company)
            document.title = '预警通知'
        this.getData()
    },
    methods: {
        async getData() {
            this.loading = true;
            this.pullUpLoading = true;

            let urlName = 'riskEvent';
            this.query.start = utils.getTimeName(this.timeActive)
            this.query.skip = this.currentPage * this.query.limit;

            if(this.query.company) {
                urlName = 'warning';
            } else {
                let tendency = this.eventActive.slice(0, 2);
                if(tendency !== '全部') {
                    this.query.tendency = tendency == "敏感" ? "负面" : tendency;
                    delete this.query.tendencies;
                }else {
                    delete this.query['tendency'];
                    delete this.query["hasWarning"];
                    this.query.tendencies = ["正面","中性", "负面"]
                }
            }
            let res = await this.baseApi[urlName](this.query)
            this.renderList = this.renderList.concat(res.list || []);
            this.pullUpLoading = this.renderList.length === res.count;
            this.loading = false;
        },
        checkIndex(index) {
            let arrLength = this.selectArr.length,
                renderLength = this.renderList.length;
            if(index === 'allCheck') {
                if (arrLength === renderLength) {
                    this.selectArr = [];
                } else if(arrLength > 0 || arrLength < 1) {
                    this.selectArr = [];
                    while (this.selectArr.length < renderLength) {
                        this.selectArr.push(this.selectArr.length)
                    }
                }
                return
            }
            if(this.selectArr.includes(index)) {
                this.selectArr = this.selectArr.filter(item => item !== index);
            } else {
                this.selectArr.push(index)
            }
        },
        sendEvent() {
            if(this.selectArr.length < 1) {
                return
            }
            this.$messagebox({
                title: '',
                message: '功能开发中，敬请期待...'
            })
        },
        openOptions(name) {
            if(this.popupVisible && this.openList === name) {
                this.openList = '';
                this.popupVisible = false;
                return
            }
            this.openList = name;
            this.popupVisible = true;
            this.activeOption = this[`${ name }Active`];
        },
        selectedOption(data) {
            this[data.keyword] = data.value;
            this.openList = "";
            this.popupVisible = false;
            this.query.skip =  0;
            this.currentPage = 0;
            this.renderList = [];
            this.getData()
        },
        async loadMore(){
            if (this.firstLoad) {
                this.firstLoad = false;
                return;
            }
            this.currentPage++;
            await this.getData();
        },
        gotoExportPage() {
            let {start, end}= this.query;
            const mailData = {
                ref: 'event',
                subject: `金融业-${this.eventActive} ${common.dateStrRange(parseInt(start), parseInt(end), "~", "YYYY-MM-DD")}`,
                query: _.assign(this.query, { sourceWeb: 'xinhua' }),
                exportModule: "events",
            }
            sessionStorage.setItem('sendEmailData', JSON.stringify(mailData));
            this.$router.push({ path: '/export?page=eventList' });
        }
    }
}
</script>

<style lang="scss" scoped>
.eventList {
    .listBg {
        width: 343px;
        margin: 8px auto 0;
        border: 1px solid #EDEDED;
        border-radius: 4px;
        .topContent {
            height: 37px;
            line-height: 37px;
            background-color: rgba(237, 237, 237, 0.3);
            padding: 14px;
            .littlePoint {
                width: 6px;
                height: 6px;
                border-radius: 50%;
                background-color: #F7634F;
                margin-right: 8px;
            }
        }
        .listBox {
            background-color: #FFFFFF;
            padding: 12px;
            .leftCheckBox {
                width: 16px;
                height: 16px;
                margin-right: 12px;
                margin-top: 2px;
                img {
                    width: 16px;
                    height: 16px;
                }
            }
        }
    }
    .footBoxBg {
        width: 100vw;
        height: 48px;
        line-height: 48px;
        .footBox {
            width: 100%;
            height: 48px;
            line-height: 48px;
            position: fixed;
            bottom: 0;
            left: 0;
            .leftBox {
                width: 120px;
                height: 100%;
                background-color: #FFFFFF;
                padding-left: 16px;
                img {
                    width: 16px;
                    height: 16px;
                    margin-right: 8px;
                }
            }
            .rightBox {
                background-color: #538DFF;
            }
        }
    }
    .place {
        height: 60px;
    }
    .exportFooter.inActive {
        background: #c9c9ca;
        pointer-events: none;
    }
}
</style>